var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrawn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "current",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    viewBox: "0 0 340 340",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_224_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.202,90.022c5.005,11.189,7.798,23.574,7.798,36.604c0,16.001-4.202,31.036-11.554,44.07     c10.859,1.836,18.759,7.22,23.936,14.386C228.783,186.443,210,206.066,210,230h20c0-13.785,11.215-25,25-25h4.73     c0.175,1.659,0.27,3.329,0.27,5c0,20-12.426,40-40,40c0,0-30-10-40-10s-20,8.954-20,20c0,5.981,2.64,11.335,6.802,15     c-4.162,3.665-6.802,9.019-6.802,15c0,11.046,10,20,20,20s40-10,40-10h10c60.75,0,110-49.25,110-110     C340,129.986,291.935,90.96,232.202,90.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.325,173.055C213.31,160.689,220,144.428,220,126.626c0-15.749-5.23-30.296-14.043-42.003     C144.356,67.118,50,110,50,110c6.684,12.031,14.627,21.899,23.358,30H65c-24.813,0-45-20.187-45-45s20.187-45,45-45h125V30H65     C29.159,30,0,59.159,0,95s29.159,65,65,65h37.911C139.169,177.392,179.724,175.892,202.325,173.055z M130,140     c-5.523,0-10-4.477-10-10s4.477-10,10-10s10,4.477,10,10S135.523,140,130,140z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrawn);
export default __webpack_public_path__ + "static/media/Prawn.5f659d0c4bd269368507914c38038bcb.svg";
export { ForwardRef as ReactComponent };